import React from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import './AutocompleteInput.css'

const AutoCompleteInputField = ({
    id,
    label,
    options,
    value,
    onChange,
    freeSolo = true,
    disableClearable = false,
    variant = 'standard',
    margin = 'normal',
    type = 'text',
}) => (
    <div className="autocomplete-container">
        <label className="autocomplete-label">{label}</label>
        <Autocomplete
            id={id}
            freeSolo={freeSolo}
            disableClearable={disableClearable}
            options={options}
            value={value}
            onChange={onChange}
            popupIcon={null}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={label}
                    margin={margin}
                    variant={variant}
                    InputProps={{
                        ...params.InputProps,
                        type: type,
                        className: 'autocomplete-input',
                        disableUnderline: true,
                    }}
                    className="autocomplete-textfield"
                />
            )}
        />
    </div>
)

export default AutoCompleteInputField
